export default {
  loginHere: '21022019-105513-0014',
  accessDetailsRequirement: '21022019-105513-0015',
  invalidEmail: '21022019-105513-0016',
  bookingReferenceInputLabel: '21022019-105513-0017',
  bookingReferenceError: '21022019-105513-0018',
  viewBooking: '21022019-105513-0019',
  customerServiceLabel: '21022019-105513-0020',
  ifYouHaveABrandAccount_regus: '21022019-105513-0013',
  ifYouHaveABrandAccount_spaces: '19032026-085908-8392',
  ifYouMadeABooking_regus: '21022019-105513-0012',
  ifYouMadeABooking_spaces: '19032026-085738-5363'
};
